import { fetchOembedJsonP } from '../util/oembed';
import BaseProvider from './base-provider';

const SDK = {
  id: 'twttier-wjs',
  globalName: 'twttr',
  url: 'https://platform.twitter.com/widgets.js',
  oembed: 'https://publish.twitter.com/oembed',
  async postInit(twttr) {
    return new Promise((resolve) => {
      twttr._e = [];
      twttr.ready = function (f) {
        twttr._e.push(f);
      };

      window['twttr']._e.push(resolve);
      window['twttr'] = twttr;
    });
  }
};


export default function Twitter() {
  const provider = BaseProvider(SDK);

  return {
    mount
  };

  async function mount(element, url) {
    element.classList.remove('social-embed--rendered');

    await provider.provideSDK();

    const oembedResponse = await fetchOembedJsonP({
      url: 'https://publish.twitter.com/oembed',
      params: {
        omit_script: true,
        url
      }
    });

    const cacheElement = await provider.createCacheElement(element, oembedResponse);

    if (cacheElement) {
      const twitter = await provider();
      twitter['events'].bind('loaded', event => event.widgets.forEach(showWidget));
      twitter.widgets.load(cacheElement);
    }
  }
}


function showWidget(widget) {
  const element = widget.parentNode;
  if (element && Object.keys(element.dataset).includes('cache')) {
    const contentElement = element.nextElementSibling;
    contentElement.innerHTML = '';
    contentElement.appendChild(widget);
  }
}
